<template>
  <div>
    <MemberProfile
      class="mb-4"
      fromSection="clientTeam"
    />
    <MemberAssociatedSites />
  </div>
</template>

<script>
import MemberProfile from '@/views/member/MemberProfile';
import MemberAssociatedSites from '@/views/member/MemberAssociatedSites';

export default {
    components: {
        MemberProfile,
        MemberAssociatedSites,
    },
};
</script>
